<template>
  <div class="row">
    <div class="col-md-6 col-sm-6 col-xs-12">
      <div class="form-group mt-10 mb-0">
        <label class="control-label" for="language">
          {{ computeCaption(fields_en['select_language'], $store.state.lang.value.toLowerCase()) }}
        </label>
      </div>
    </div>
    <div class="col-md-6 col-sm-6 col-xs-12">
      <div class="form-group text-center-mobile">
        <el-radio-group v-model="selectedLanguage" size="medium">
          <el-radio-button tabindex="0" value="EN" inline label="EN" key="EN">
            {{ computeCaption(fields_en['english'], $store.state.lang.value.toLowerCase()) }}
          </el-radio-button>
          <el-radio-button tabindex="0" inline value="ES" label="ES" key="ES">
            {{ computeCaption(fields_en['spanish'], $store.state.lang.value.toLowerCase()) }}
          </el-radio-button>
          <el-radio-button tabindex="0" inline value="ZH" label="ZH" key="ZH">
            {{ computeCaption(fields_en['chinese'], $store.state.lang.value.toLowerCase()) }}
          </el-radio-button>
        </el-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
  import {RadioButton, RadioGroup} from 'element-ui'
  import {TranslationsUtils} from '../../../utils/Translations'
  export default {
    mixins: [TranslationsUtils],
    data () {
      return {
        selectedLanguage: this.$store.state.lang.value,
        fields_en: {
          select_language: 'Select language',
          english: 'English',
          spanish: 'Spanish',
          chinese: 'Chinese'
        }
      }
    },
    components: {
      [RadioButton.name]: RadioButton,
      [RadioGroup.name]: RadioGroup
    },
    watch: {
      selectedLanguage () {
        this.$store.commit('setLang', { value: this.selectedLanguage })
        const html = document.documentElement
        html.setAttribute('lang', this.$store.state.lang.value.toLowerCase())
      }
    }
  }
</script>

<style scoped>
.text-center-mobile {
  text-align: right;
}

@media (max-width: 767px) {
  .text-center-mobile {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/LanguageButtonGroup.vue